
export default function Demerits() {
  const demerits = [
    {
      icon: 'ri-calendar-line',
      title: '年5回未満の利用だと年会費5,500円が発生',
      description: '初年度は無料ですが、年間5回以上のカード利用がないと翌年度は年会費5,500円（税込）がかかります。ただし、5回という条件は非常にハードルが低く、月1回程度の利用で簡単にクリアできます。サブスクの支払いを設定しておけば自動的に条件達成できます。',
      solution: '月1回程度の利用、またはサブスク支払いの設定で簡単にクリア可能',
    },
    {
      icon: 'ri-exchange-line',
      title: 'ポイントの使い道が限定的',
      description: 'Gold Timeのポイントは自動でJデポ（請求時値引き）に交換されるため、他社ポイントへの交換やマイルへの移行はできません。ポイントの使い道を自分で選びたい方には向いていません。ただし、ポイント失効の心配がなく、確実に値引きとして還元される点はメリットでもあります。',
      solution: '確実に値引きとして還元されるため、ポイント管理が苦手な方には最適',
    },
    {
      icon: 'ri-user-line',
      title: '学生は申込不可',
      description: '申込条件が「年齢20歳以上で安定した収入のある方（学生を除く）」となっており、学生の方は申し込むことができません。学生の方は他のカードを検討する必要があります。',
      solution: '社会人になってから申し込むか、学生向けカードを検討',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1A1A2E] mb-3 text-center">
          ジャックス Gold Timeのデメリット
        </h2>
        <p className="text-gray-600 text-center mb-12">申し込み前に知っておきたい注意点</p>

        <div className="space-y-6">
          {demerits.map((demerit, index) => (
            <div key={index} className="bg-[#FFF8F0] border border-[#FFE0B2] rounded-xl p-6 md:p-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF9800] rounded-full flex-shrink-0">
                  <i className={`${demerit.icon} text-white text-xl`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3 flex-wrap">
                    <span className="bg-[#FF9800] text-white text-xs font-bold px-3 py-1 rounded-full">
                      注意点{index + 1}
                    </span>
                    <h3 className="text-lg md:text-xl font-bold text-[#1A1A2E]">{demerit.title}</h3>
                  </div>
                  <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-3">
                    {demerit.description}
                  </p>
                  <div className="bg-white border-l-4 border-[#4CAF50] px-4 py-2 rounded">
                    <p className="text-[#2E7D32] text-xs md:text-sm font-medium">
                      <i className="ri-lightbulb-line mr-1"></i>
                      対策: {demerit.solution}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
